export const calculateLinearRegressionLine = (
  values: Array<number | null | undefined>
): Array<number | null> => {
  const points = values
    .map((value, index) => ({ x: index, y: value }))
    .filter((point): point is { x: number; y: number } => point.y !== null && point.y !== undefined);

  if (points.length === 0) {
    return values.map(() => null);
  }

  if (points.length === 1) {
    return values.map((value) => (value === null || value === undefined ? null : points[0].y));
  }

  const sumX = points.reduce((sum, point) => sum + point.x, 0);
  const sumY = points.reduce((sum, point) => sum + point.y, 0);
  const sumXY = points.reduce((sum, point) => sum + (point.x * point.y), 0);
  const sumXX = points.reduce((sum, point) => sum + (point.x * point.x), 0);
  const n = points.length;
  const denominator = (n * sumXX) - (sumX * sumX);
  const slope = denominator === 0 ? 0 : ((n * sumXY) - (sumX * sumY)) / denominator;
  const intercept = (sumY - (slope * sumX)) / n;

  return values.map((value, index) => (
    value === null || value === undefined ? null : (slope * index) + intercept
  ));
};
